export const GRADE_TAB_SELECTION = 'Grade Tab Selection'
export const CONTENT_TYPE_COURSE_SLM = 'courseSlm'
export const CONTENT_TYPE_KIT_TEACH = 'kitTeachSection'
export const TEACH = 'teach'
export const DEFAULT_PAGE_TITLE = 'My Kits'
